import { useEffect } from 'react';

import type { UsePhoneEffectsProps } from '@app/components/Phone/types';

export const usePhoneEffects = ({
  initValue,
  errorHandler,
  updatePopoverWidthHandler,
  onFinishHandler,
  onValidateHandler,
  onUpdatePhoneHandler,
}: UsePhoneEffectsProps) => {
  useEffect(() => {
    initValue();
  }, [initValue]);

  useEffect(() => {
    errorHandler();
  }, [errorHandler]);

  useEffect(() => {
    onFinishHandler();
  }, [onFinishHandler]);

  useEffect(() => {
    onValidateHandler();
  }, [onValidateHandler]);

  useEffect(() => {
    updatePopoverWidthHandler();
    window.addEventListener('resize', updatePopoverWidthHandler);

    return () => {
      window.removeEventListener('resize', updatePopoverWidthHandler);
    };
  }, [updatePopoverWidthHandler]);

  useEffect(() => {
    onUpdatePhoneHandler();
  }, [onUpdatePhoneHandler]);
};
